import { call, put, takeEvery } from "redux-saga/effects";
import AXIOS_INSTANCE from "../../utils/Config";

import {
  loginLoading,
  submitLoginActionDispatcher,
  submitLoginErrorDispatcher,
  SUBMIT_LOGIN_ACTION_REQUESTED,
} from "./Action"; // Path should come here
import axios from "axios";
import { toastr } from "react-redux-toastr";
import USOBApiRequest from "../../utils/ApiUrls";

const postLoginAPI = async (postData) => {
  if (postData.SSO) {
    try {
      console.log(
        "process.env.REACT_APP_ENV_TYPE: ",
        process.env.REACT_APP_ENV_TYPE
      );
      const ssoResult = await axios.post(
        process.env.REACT_APP_ENV_TYPE === "production"
          ? process.env.REACT_APP_SSO_PROD_URL
          : process.env.REACT_APP_SSO_DEV_URL,
        {
          ...postData.ssoData,
        },
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        }
      );
      if (ssoResult.data.message) {
        const result = await AXIOS_INSTANCE.post("/CustomerPortal/LogOn", {
          Token: "teramatrix",
          ...postData,
        });
        return result;
      } else {
        toastr.error(
          "Unauthorized Access! Please login with correct credentials."
        );
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Handle 401 Unauthorized specifically
        toastr.error(
          "Unauthorized Access! Please login with correct credentials."
        );
      } else {
        toastr.error("An error occurred. Please try again later.");
      }
    }
    // const ssoResult = await axios.post(
    //   "https://volvosso.siplsolutions.com/verify-sso-token",
    //   // "http://10.10.11.73/volvo-sso/public/verify-sso-token",
    //   // "http://10.10.11.57/volvo-sso/public/verify-sso-token",
    //   {
    //     ...postData.ssoData,
    //   },
    //   {
    //     headers: {
    //       'Access-Control-Allow-Origin': '*', // Change to specific origin if possible
    //       'Content-Type': 'application/json', // Adjust content type if needed
    //       // Add any other headers as required
    //     },
    //   }
    // );
    // if (ssoResult.data.message) {
    //   const result = await AXIOS_INSTANCE.post("/CustomerPortal/LogOn", {
    //     Token: "teramatrix",
    //     ...postData,
    //   });
    //   return result;
    // }else{
    //   toastr.error("Un-Aurthorised Access! Please Login with correct credentials.");
    // }
  } else {
    const result = await AXIOS_INSTANCE.post("/CustomerPortal/LogOn", {
      Token: "teramatrix",
      ...postData,
    });
    return result;
  }
};

const postLoginAttemptsAPI = async (userData) => {
  try {
    const payload = {
      user_id: userData.UserId,
      customer_id: userData.CustomerId,
      user_name: userData.UserName,
      role: userData.RoleName,
      area: userData.UserArea,
      region: userData.UserRegion
    };
    
    await axios.post(
      USOBApiRequest.USOBApiBaseURL + `/login-attempts`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  } catch (error) {
    console.error("Error logging login attempt:", error);
  }
};

function* submitLoginSaga({ postData }) {
  try {
    yield put(loginLoading(true));
    const data = yield call(postLoginAPI, postData); 
    // Call login attempts API BEFORE dispatcher (dispatcher may cause redirect)
    if (data?.data?.Status === "1" && data?.data?.Message === "User exist") {
      yield call(postLoginAttemptsAPI, data.data);
    }
    yield put(submitLoginActionDispatcher(data));
    yield put(submitLoginErrorDispatcher({}));
    yield put(loginLoading(false));
  } catch (e) {
    yield put(submitLoginActionDispatcher({}));
    yield put(submitLoginErrorDispatcher(e.response.data));
    yield put(loginLoading(false));
  }
}

function* submitLoginWatcher() {
  yield takeEvery(SUBMIT_LOGIN_ACTION_REQUESTED, submitLoginSaga);
}
export default submitLoginWatcher;
